module.exports = __webpack_public_path__ + "static/media/financial-stress-and-thinking-large@2x.b8c00b4b.png";